import { useCallback } from "react";
import { useDispatch } from "react-redux";
import UiActions from "actions/UiActions";

const useShowCommonModal = () => {
  const dispatch = useDispatch();

  const showModal = useCallback((params = {}) => {
    const { text, headerText, confirm, size, okButtonText, cancelButtonText, markdown } = params;

    return dispatch(
      UiActions.showModal(text, headerText, confirm, size, okButtonText, cancelButtonText, false, markdown)
    );
  }, [dispatch]);

  return showModal;
};

export default useShowCommonModal;
